/**
 * ReferralCampaignBadge Component
 *
 * Displays a stylized badge showing the referral code with "2x" when the user:
 * - Is bound to a VIP referral code (e.g., BIRDI)
 * - Hasn't exceeded the bonus cap
 *
 * Uses purple branding consistent with ReferralCampaignProgress.
 */

import { useReferralCampaign } from '@/hooks/useReferralCampaign';

// Referral campaign brand colors (purple theme)
const REFERRAL_PURPLE = '#A78BFA';
const REFERRAL_PURPLE_DARK = '#7C3AED';

export function ReferralCampaignBadge() {
  const { campaignData, isLoading } = useReferralCampaign();

  // Only show badge if user is eligible and hasn't reached the cap
  if (isLoading || !campaignData?.isEligible || campaignData?.remainingBonus <= 0) {
    return null;
  }

  // Show the bound code (e.g., "BIRDI") or generic "VIP" if no code
  const codeLabel = campaignData.boundReferralCode || 'VIP';

  return (
    <div
      className="inline-flex items-center gap-1.5 px-2 py-1 rounded-full"
      style={{
        background: 'rgba(240, 240, 240, 0.95)',
        border: `2px solid ${REFERRAL_PURPLE}`,
        boxShadow: `0 0 12px rgba(167, 139, 250, 0.4), 0 0 8px rgba(124, 58, 237, 0.3)`,
      }}
    >
      <span
        className="text-xs font-bold"
        style={{
          background: `linear-gradient(90deg, ${REFERRAL_PURPLE_DARK}, ${REFERRAL_PURPLE})`,
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          fontFamily: 'Outfit, sans-serif',
        }}
      >
        {codeLabel} 2x
      </span>
    </div>
  );
}
